import { ReactNode, useCallback, useState } from "react";
import { Col, Row, Modal } from "antd";
import { FullscreenOutlined } from "@ant-design/icons";

import styles from "./index.module.less";
import OnGoingStatusCard from "./OnGoingStatusCard";
import ParkingStatusCard from "./ParkingStatusCard";
import KeyFobStatusCard from "./KeyFobStatusCard";
import ParkingOccupancyStatusCard from "./ParkingOccupancyStatusCard";
import TodaysVisitorsCard from "./TodaysVisitorsCard";
import NewsSlider from "./NewsSlider";
import { useDashboard } from "./index.hook";

const Dashboard = () => {
  const config = useDashboard();
  const [activeModalId, setActiveModalId] = useState<string | null>(null);

  const handleMaximizeClick = (id: string) => {
    setActiveModalId(id);
  };

  const closeModal = () => {
    setActiveModalId(null);
  };

  const renderModalContent = (activeModalID: string | null) => {
    switch (activeModalID) {
      case "ongoingStatus":
        return <OnGoingStatusCard data={config.dashboardData?.ongoingStatusData} parkingStatusCount={config.dashboardData?.parkingStatusCount} loading={config.loading} isFullScreen />;
      case "parkingStatus":
        return <ParkingStatusCard data={config.dashboardData?.vehicleTypeParkingStatusData} loading={config.loading} isFullScreen />;
      case "keyFobStatus":
        return <KeyFobStatusCard data={config.dashboardData?.keyfobStatusData} loading={config.loading} isFullScreen />;
      case "parkingOccupancy":
        return <ParkingOccupancyStatusCard data={config.dashboardData?.parkingOccupancyData} loading={config.loading} isFullScreen />;
      case "todaysVisitors":
        return <TodaysVisitorsCard data={config.dashboardData?.todaysVisitorsData} loading={config.loading} isFullScreen />;
      default:
        return null;
    }
  };

  const CardWrapper = useCallback(
    ({ children, id }: { children: ReactNode; id: string }) => (
      <div className={styles["card-wrapper"]}>
        <FullscreenOutlined className={styles["maximize-icon"]} onClick={() => handleMaximizeClick(id)} />
        {children}
      </div>
    ),
    []
  );

  return (
    <div className={styles["dashboard-container"]}>
      <Row gutter={[16, 16]} className={styles["section1"]}>
        <Col xxl={6} xl={6} lg={6} md={24} sm={24} xs={24}>
          <CardWrapper id="ongoingStatus">
            <OnGoingStatusCard data={config.dashboardData?.ongoingStatusData} parkingStatusCount={config.dashboardData?.parkingStatusCount} loading={config.loading} />
          </CardWrapper>
        </Col>
        <Col xxl={18} xl={18} lg={18} md={24} sm={24} xs={24}>
          <CardWrapper id="parkingStatus">
            <ParkingStatusCard data={config.dashboardData?.vehicleTypeParkingStatusData} loading={config.loading} />
          </CardWrapper>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className={styles["section2"]}>
        <Col xxl={6} xl={6} lg={6} md={24} sm={24} xs={24}>
          <CardWrapper id="keyFobStatus">
            <KeyFobStatusCard data={config.dashboardData?.keyfobStatusData} loading={config.loading} />
          </CardWrapper>
        </Col>
        <Col xxl={7} xl={7} lg={7} md={24} sm={24} xs={24}>
          <CardWrapper id="parkingOccupancy">
            <ParkingOccupancyStatusCard data={config.dashboardData?.parkingOccupancyData} loading={config.loading} />
          </CardWrapper>
        </Col>
        <Col xxl={11} xl={11} lg={11} md={24} sm={24} xs={24}>
          <CardWrapper id="todaysVisitors">
            <TodaysVisitorsCard data={config.dashboardData?.todaysVisitorsData} loading={config.loading} />
          </CardWrapper>
        </Col>
      </Row>

      <NewsSlider list={config.dashboardData?.notificationList} loading={config.loading} />

      <Modal //
        visible={!!activeModalId}
        onCancel={closeModal}
        footer={null}
        width="100vw"
        centered
        style={{ top: 0 }}
        bodyStyle={{ height: "95vh", padding: 0 }}
      >
        <div style={{ height: "100%", overflow: "auto", padding: "20px" }}>{renderModalContent(activeModalId)}</div>
      </Modal>
    </div>
  );
};

export default Dashboard;
